import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { BREAKDOWNS } from 'lumen/utils/central-mapping-constants';

import StayRestrictionsAccordion, {
  type StayRestrictionsAccordionState,
} from './stay-restrictions-accordion';

interface StayRestrictionsPanelSignature {
  Args: {
    deepDiscountState: StayRestrictionsAccordionState;
    hotelState: StayRestrictionsAccordionState;
    showDeepDiscount: boolean;
  };
}

const StayRestrictionsPanel = <template>
  <StayRestrictionsAccordion
    @id="hotel-min-los"
    @state={{@hotelState}}
    @title={{t "general.hotel"}}
  />
  {{#if @showDeepDiscount}}
    <StayRestrictionsAccordion
      @id="deep-discount-min-los"
      @state={{@deepDiscountState}}
      @title={{t "pricing_assistant.stay_restrictions.deep_discount"}}
    >
      <:settingsLink>
        <LinkTo
          @query={{hash breakdown=BREAKDOWNS.STAY_RESTRICTION_RATE_GROUP}}
          @route="hotel.settings.central-mapping.mapping"
          class="prism-link prism-link--small prism-link--standalone"
          rel="noopener noreferrer"
          target="_blank"
        >
          <span class="flex items-center gap-50">
            {{t
              "pricing_assistant.stay_restrictions.view_deep_discount_rates_in_settings"
            }}
            <PrismIcon
              @color="inherit"
              @name="link-out"
              @size="small"
              aria-hidden="true"
            />
          </span>
        </LinkTo>
      </:settingsLink>
    </StayRestrictionsAccordion>
  {{/if}}
</template> satisfies TOC<StayRestrictionsPanelSignature>;

export default StayRestrictionsPanel;
